import ServiceBase from './ServiceBase';

export default class CustomerAccountService extends ServiceBase {
    async getCustomers() {
        var results = await this.requestJson({
            url: `api/admin/account`,
            method: "GET"
        });

        return results;
    }

    async getCustomerRef(showParentAccounts = true, showChildAccounts = true) {
        var result = await this.requestJson({
            url: `api/admin/account/ref`,
            method: "POST",
            data: { "showParentAccounts": showParentAccounts, "showChildAccounts": showChildAccounts }
        })

        return result;
    }

    async getCustomer(id) {
        var result = await this.requestJson({
            url: `api/admin/account/${id}`,
            method: "GET"
        });

        return result;
    }

    async updateCustomer(customer) {
        var result = await this.requestJson({
            url: `api/admin/account/${customer.id}`,
            method: "PUT",
            data: customer
        })

        return result;
    }

    async createCustomer(customer) {
        var result = await this.requestJson({
            url: `api/admin/account/`,
            method: "POST",
            data: customer
        })

        return result;
    }

    async saveClinician(clinician) {
        var result = await this.requestJson({
            url: `api/admin/account/clinician`,
            method: "POST",
            data: clinician
        });

        return result;
    }

    async linkAccount(parentAccountId, childAccountId) {
        var result = await this.requestJson({
            url: `api/admin/account/link`,
            method: "POST",
            data: { "parentAccountId": parentAccountId, "childAccountId": childAccountId }
        });

        return result;
    }

    async removeLinkedAccount(parentAccountId, childAccountId) {
        var result = await this.requestJson({
            url: `api/admin/account/link`,
            method: "DELETE",
            data: { "parentAccountId": parentAccountId, "childAccountId": childAccountId }
        });

        return result;
    }

    async transitionAccount(accountId, contacts) {
        var result = await this.requestJson({
            url: `api/admin/account/transition`,
            method: "POST",
            data: { "accountId": accountId, "contacts": contacts }
        });

        return result;
    }
}